import { Reveal, GoldLine, SectionHeading } from "@/components/Reveal";

const Section = ({ title, children }) => (
  <Reveal>
    <section className="mt-14">
      <h2 className="font-display text-2xl font-light text-[#E5C776]">{title}</h2>
      <div className="mt-5 space-y-4 text-sm sm:text-base text-[#A5A5A5] font-light leading-relaxed">
        {children}
      </div>
    </section>
  </Reveal>
);

export default function Privacy() {
  return (
    <main data-testid="privacy-page" className="bg-[#080808] min-h-screen pt-40 pb-24">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <SectionHeading eyebrow="Documento Legale" title="Informativa" goldWord="Privacy." />
        <Reveal delay={0.2}>
          <p className="mt-10 text-sm text-[#A5A5A5] font-light">
            Ultimo aggiornamento: ottobre 2026 — ai sensi del Regolamento (UE)
            2016/679 ("GDPR") e della normativa nazionale applicabile.
          </p>
        </Reveal>

        <Section title="1. Titolare del trattamento">
          <p>
            Il titolare del trattamento dei dati personali è:
          </p>
          <p className="text-[#F5F2EB]">
            BILLIONS GROUP LTD
            <br />
            Viale Tsar Boris III n° 85, Sofia (Bulgaria)
            <br />
            P.I. 208789980
          </p>
          <p>
            Per qualsiasi richiesta relativa alla privacy è possibile scrivere
            tramite il modulo contatti presente su questo sito.
          </p>
        </Section>

        <Section title="2. Dati raccolti e finalità">
          <p>Attraverso questo sito raccogliamo esclusivamente i dati che ci fornite volontariamente:</p>
          <p>
            <span className="text-[#F5F2EB]">Modulo Contatti e modulo Diventa Partner:</span>{" "}
            nome, email, azienda, telefono, fascia di investimento indicativa,
            divisione di interesse e contenuto del messaggio. Questi dati sono
            trattati per rispondere alle vostre richieste e valutare eventuali
            candidature di partnership.
          </p>
          <p>
            <span className="text-[#F5F2EB]">Dati di navigazione:</span> i
            sistemi informatici acquisiscono alcuni dati tecnici (indirizzo IP,
            browser, orario di accesso) necessari al funzionamento e alla
            sicurezza del sito.
          </p>
        </Section>

        <Section title="3. Base giuridica">
          <p>
            Il trattamento si fonda sull'esecuzione di misure precontrattuali
            adottate su vostra richiesta (art. 6, par. 1, lett. b GDPR) e sul
            legittimo interesse del titolare alla sicurezza dei propri sistemi
            (art. 6, par. 1, lett. f GDPR).
          </p>
        </Section>

        <Section title="4. Conservazione e comunicazione">
          <p>
            I dati sono conservati per il tempo necessario a gestire la
            richiesta e, in caso di partnership avviata, per la durata del
            rapporto secondo i termini di legge. I dati non sono ceduti a terzi
            né diffusi; possono essere trattati da fornitori tecnici che
            operano come responsabili del trattamento nominati dal titolare.
          </p>
        </Section>

        <Section title="5. Cookie">
          <p>
            Questo sito utilizza unicamente cookie tecnici e strumenti di
            memorizzazione locale necessari al funzionamento del servizio (ad
            esempio la sessione dell'area amministrativa e la memorizzazione
            delle preferenze espresse nel banner cookie).
          </p>
          <p>
            Non vengono utilizzati cookie di profilazione, cookie pubblicitari
            né cookie di terze parti a fini di marketing. Non è pertanto
            richiesto il consenso preventivo ai sensi della normativa vigente.
          </p>
        </Section>

        <Section title="6. Diritti dell'interessato">
          <p>
            In qualunque momento potete esercitare i diritti previsti dagli
            artt. 15-22 GDPR: accesso, rettifica, cancellazione, limitazione,
            portabilità e opposizione al trattamento. Potete inoltre proporre
            reclamo all'autorità di controllo competente.
          </p>
          <p>
            Per esercitare i vostri diritti scrivete al titolare tramite il
            modulo contatti di questo sito.
          </p>
        </Section>

        <GoldLine className="mt-16 w-24" />
        <Reveal>
          <p className="mt-8 text-xs text-[#A5A5A5]/60 font-light leading-relaxed">
            BILLIONS GROUP LTD · Viale Tsar Boris III n° 85, Sofia · P.I.
            208789980
          </p>
        </Reveal>
      </div>
    </main>
  );
}
